
/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  PurchaseOrderMonitoringSearchResultResource,
  PurchaseOrderResource,
  PurchaseOrderUpsertRequest,
} from '../models';
import {
    PurchaseOrderMonitoringSearchResultResourceFromJSON,
    PurchaseOrderMonitoringSearchResultResourceToJSON,
    PurchaseOrderResourceFromJSON,
    PurchaseOrderResourceToJSON,
    PurchaseOrderUpsertRequestFromJSON,
    PurchaseOrderUpsertRequestToJSON,
} from '../models';

export interface GetPurchaseOrderByNumberRequest {
    companyId: string;
    purchaseOrderNumber: string;
}

export interface SearchPurchaseOrdersRequest {
    page?: number;
    size?: number;
}

export interface UpsertProjectPurchaseOrderRequest {
    projectId: string;
    purchaseOrderUpsertRequest: PurchaseOrderUpsertRequest;
}

export interface UpsertQuotePurchaseOrderRequest {
    quoteId: string;
    purchaseOrderUpsertRequest: PurchaseOrderUpsertRequest;
}

/**
 * 
 */
export class PurchaseOrderApi extends runtime.BaseAPI {

    /**
          */
    async getPurchaseOrderByNumberRaw(requestParameters: GetPurchaseOrderByNumberRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<PurchaseOrderResource>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getPurchaseOrderByNumber().'
            );
        }

        if (requestParameters['purchaseOrderNumber'] == null) {
            throw new runtime.RequiredError(
                'purchaseOrderNumber',
                'Required parameter "purchaseOrderNumber" was null or undefined when calling getPurchaseOrderByNumber().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['purchaseOrderNumber'] != null) {
            queryParameters['purchaseOrderNumber'] = requestParameters['purchaseOrderNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<PurchaseOrderResource>({
            path: `/project-client/api/purchase-order/company/{companyId}`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=PurchaseOrderResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getPurchaseOrderByNumber(requestParameters: GetPurchaseOrderByNumberRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<PurchaseOrderResource> {
        const response = await this.getPurchaseOrderByNumberRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async searchPurchaseOrdersRaw(requestParameters: SearchPurchaseOrdersRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<PurchaseOrderMonitoringSearchResultResource>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<PurchaseOrderMonitoringSearchResultResource>({
            path: `/project-client/api/purchase-order`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=PurchaseOrderMonitoringSearchResultResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async searchPurchaseOrders(requestParameters: SearchPurchaseOrdersRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<PurchaseOrderMonitoringSearchResultResource> {
        const response = await this.searchPurchaseOrdersRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async upsertProjectPurchaseOrderRaw(requestParameters: UpsertProjectPurchaseOrderRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling upsertProjectPurchaseOrder().'
            );
        }

        if (requestParameters['purchaseOrderUpsertRequest'] == null) {
            throw new runtime.RequiredError(
                'purchaseOrderUpsertRequest',
                'Required parameter "purchaseOrderUpsertRequest" was null or undefined when calling upsertProjectPurchaseOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-client/api/purchase-order/project/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PurchaseOrderUpsertRequestToJSON(requestParameters['purchaseOrderUpsertRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async upsertProjectPurchaseOrder(requestParameters: UpsertProjectPurchaseOrderRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertProjectPurchaseOrderRaw(requestParameters, initOverrides);
    }

    /**
          */
    async upsertQuotePurchaseOrderRaw(requestParameters: UpsertQuotePurchaseOrderRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['quoteId'] == null) {
            throw new runtime.RequiredError(
                'quoteId',
                'Required parameter "quoteId" was null or undefined when calling upsertQuotePurchaseOrder().'
            );
        }

        if (requestParameters['purchaseOrderUpsertRequest'] == null) {
            throw new runtime.RequiredError(
                'purchaseOrderUpsertRequest',
                'Required parameter "purchaseOrderUpsertRequest" was null or undefined when calling upsertQuotePurchaseOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-client/api/purchase-order/quote/{quoteId}`.replace(`{${"quoteId"}}`, encodeURIComponent(String(requestParameters['quoteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PurchaseOrderUpsertRequestToJSON(requestParameters['purchaseOrderUpsertRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async upsertQuotePurchaseOrder(requestParameters: UpsertQuotePurchaseOrderRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertQuotePurchaseOrderRaw(requestParameters, initOverrides);
    }

}
